import { NodeRules } from '@candulabs/craft';

import { canDropFormFieldIntoFormStep } from '@candu-ai/forms/editor-utils';
import { BuiltInComponents } from 'craft/constants';

export const getFormFieldNodeRules = () =>
  ({
    canMoveIn: () => false,
    canDrop(dropTarget, self, helpers): boolean {
      // We can drop a FormTextInput only if the target is/has a FormStep ancestor, that is NOT a submit step
      if (dropTarget.data.name === BuiltInComponents.FormStep) {
        return canDropFormFieldIntoFormStep(dropTarget, self, helpers);
      }

      const nodeApi = helpers(dropTarget.id);
      const ancestors = nodeApi.ancestors(true);

      if (
        ancestors.some((ancestor) => {
          const ancestorNode = nodeApi.nodes[ancestor];
          return [
            BuiltInComponents.FormMultiSelectCardGroup,
            BuiltInComponents.FormSingleSelectCardGroup,
          ].includes(ancestorNode.data.name as BuiltInComponents);
        })
      ) {
        return false;
      }
      return ancestors.some((ancestor) => {
        const ancestorNode = nodeApi.nodes[ancestor];
        return (
          ancestorNode.data.name === BuiltInComponents.FormStep &&
          canDropFormFieldIntoFormStep(ancestorNode, self, helpers)
        );
      });
    },
  } as Partial<NodeRules>);
